var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"preview"},[_c('landdetail',{attrs:{"is_preview":1}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }